module.exports = __webpack_public_path__ + "img/home_header_sm.f03cf140.png";